// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const AxisLeft = ({ yScale, innerWidth, tickOffset = 3 }) =>
	yScale.ticks(6).map(tickValue => (
		<g key={tickValue} className="tick" transform={`translate(0,${ yScale(tickValue) })`}>
			<line x2={innerWidth} />
			<text
				key={tickValue}
				style={{ textAnchor: 'end' }}
				x={-tickOffset}
				dy=".32em"
			>
				{tickValue}
			</text>
		</g>
	));

